import React from "react";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import { FormattedMessage, useIntl } from "react-intl";
import { END_POINTS } from "constants/APIConstant";
import fetch from "auth/FetchInterceptor";
import { useDispatch, useSelector } from "react-redux";
import { refreshTokenAction, showLoading, signIn } from "redux/actions/Auth.js";
import { APP_PREFIX_PATH } from "configs/AppConfig.js";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { CookiesProvider, useCookies } from "react-cookie";
import ReactGA from "react-ga4";

function Login() {
  const intl = useIntl();
  const [cookies, setCookie] = useCookies(["user-ip"]);
  let navigate = useNavigate();

  // const imgLogin = process.env.PUBLIC_URL + "/image/bubble.gif";

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/login", title: "Login Page" });
  }, []);

  const location = useLocation();

  const dispatch = useDispatch();
  const dir = useSelector(({ theme }) => theme.direction);
  const { loading, token, id, userName } = useSelector(({ auth }) => {
    return auth;
  });

  React.useEffect(() => {
    if (token !== null && token !== "" && token !== undefined) {
      location?.state?.prevUrl
        ? navigate(`../${location?.state?.prevUrl}`)
        : navigate(`../`);
    }
  }, [token]);

  const [ipAddress, setIpAddress] = React.useState();

  const defaultState = {
    personalKey: null,
    password: null,
    //ipAddress: ipAddress
  };

  const [changeState, setChangeState] = React.useState(defaultState);
  const [showPassword, setShowPassword] = React.useState(false);

  async function getIpAddress() {
    return await fetch
      .get(END_POINTS.IP_ADDRESS)
      .then((res) => {
        setIpAddress(res.ip);
        setCookie("user-ip", res.ip, { path: "/" });
      })
      .catch((e) => {
        // console.log(e);
      });
  }

  React.useEffect(() => {
    let timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
      getIpAddress();
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  const handelData = (e) => {
    let infoData = { ...changeState };
    infoData[e.target.name] = e.target.value;
    setChangeState({
      ...infoData,
      // ipAddress: ipAddress
    });
  };

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  const onLogin = (e) => {
    e.preventDefault();
    dispatch(showLoading());
    dispatch(signIn(changeState));
    if (token) {
      localStorage.setItem("passwordUserCapmas", changeState.password);
      ReactGA.set({
        userId: userName,
      });
    }
  };
  return (
    <>
      <div>
        <InnerHeader
          breadcrumb={[
            {
              title: <FormattedMessage id="login" />,
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "enter-username-pass" })}
        />
        <div className="browsetopic-box alls my-0 py-5">
          <div className="container">
            <form
              className="row d-flex justify-content-between align-items-center gy-3"
              onSubmit={onLogin}
            >
              <div className="col-12 col-lg-4 ">
                <div className="item-form coll">
                  <label htmlFor="personalKey">
                    {" "}
                    <FormattedMessage id="user-name" />{" "}
                  </label>
                  <input
                    name="personalKey"
                    id="personalKey"
                    onChange={handelData}
                    type="text"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity(
                        intl.formatMessage({
                          id: "username-required-validation",
                        })
                      )
                    }
                    className=" form-control"
                    placeholder={intl.formatMessage({ id: "user-name" })}
                  />
                </div>
                <div className="item-form coll mt-4">
                  <label htmlFor="password">
                    {" "}
                    <FormattedMessage id="password" />{" "}
                  </label>
                  <div style={{ position: "relative", width: "100%" }}>
                    <input
                      name="password"
                      id="password"
                      onChange={handelData}
                      type={showPassword ? "text" : "password"}
                      required
                      onInvalid={(e) =>
                        e.target.setCustomValidity(
                          intl.formatMessage({
                            id: "password-required-validation",
                          })
                        )
                      }
                      className=" form-control"
                      placeholder={intl.formatMessage({ id: "password" })}
                    />
                    <button
                      type="button"
                      className="password-toggle-btn"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: dir === "rtl" ? "auto" : "-20px",
                        left: dir === "rtl" ? "-20px" : "auto",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "16px",
                        color: "#666",
                      }}
                    >
                      {showPassword ? "👁️" : "👁️‍🗨️"}
                    </button>
                  </div>
                </div>
                <button type="submit" className="main-btn mt-5">
                  <span>
                    {loading ? (
                      <CircularProgress sx={{ color: "#fff" }} size={15} />
                    ) : (
                      <FormattedMessage id="login" />
                    )}
                  </span>
                </button>
              </div>
            </form>
            <div className="mt-3">
              <Link to={`${APP_PREFIX_PATH}/forgetPass`}>
                <span style={{ color: "#fff" }}>
                  <FormattedMessage id="forgetPass" />
                </span>
              </Link>
            </div>
            <div className="mt-4">
              <span style={{ color: "#fff", paddingInlineEnd: "0.75rem" }}>
                <FormattedMessage id="don't-have-an-account" />
              </span>
              <Link to={`${APP_PREFIX_PATH}/register`}>
                <span style={{ color: "#fff" }}>
                  <u>
                    <FormattedMessage id="register-website" />
                  </u>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
